module.exports = __webpack_public_path__ + "static/media/sign-in-investure.6ebdc1b1.png";